
import { Component, Vue, Watch } from 'vue-property-decorator';

import SelectField from '../../../../framework/fields/SelectField.vue';
import { sharedState } from '../../../../framework/state';
import { deleteResource, getResourcePagingNew, getResourcesNew } from '../../../../framework/client/resource';
import { getEnumerationOptions, getOptionLabel } from '../../../../framework/service/options';

import { errorToast, successToast } from '../../../service/toast_service';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';

import AutoCompleteMultipleField from '../../../fields/AutoCompleteMultipleField.vue';
import { VehicleMake } from '../../../../../common/application/model/VehicleMake';
import { VehicleMakeType } from '../../../../../common/application/model/enums/VehicleMakeType';
import ParameterService from "../../../service/parameter_service";

@Component({
    components: {
        SelectField,
        AutoCompleteMultipleField,
    },
})
export default class VehicleMakes extends Vue {
    readonly resourceType = ApplicationResource.VEHICLE_MAKE;
    parameterService = new ParameterService(this.resourceType);

    shared = sharedState;
    local = {
        rows: [] as VehicleMake[],
        total: 0,
        loading: false,
        selected: undefined as VehicleMake | undefined,
        vehicleMakeTypeOptions: [] as { id: string | undefined; label: string }[],
        parameters: this.parameterService.get(),
    };

    async mounted() {
        this.local.loading = true;

        this.local.vehicleMakeTypeOptions = getEnumerationOptions(
            'VehicleMakeType',
            Object.keys(VehicleMakeType),
            this,
        );
        await this.loadAsyncData();

        this.local.loading = false;
    }

    add() {
        this.$router.push(`/${this.resourceType}/add`);
    }

    edit(id?: string) {
        if (id) {
            this.$router.push(`/${this.resourceType}/${id}/edit`);
        } else if (this.local.selected) {
            this.$router.push(`/${this.resourceType}/${this.local.selected.id}/edit`);
        }
    }

    confirmDelete() {
        this.$buefy.dialog.confirm({
            title: this.$t('title.confirmDelete').toString(),
            message: this.$t('message.confirmDelete').toString(),
            cancelText: this.$t('button.cancel').toString(),
            confirmText: this.$t('button.ok').toString(),
            type: 'is-success',
            onConfirm: async () => {
                if (this.local.selected) {
                    try {
                        await deleteResource(this.resourceType, this.local.selected.id);
                        successToast(this, 'message.resourceDeleted');
                        await this.loadAsyncData();
                    } catch (e) {
                        errorToast(this);
                    }
                }
            },
        });
    }

    async onSortChange(field: string, order: 'desc' | 'asc') {
        this.local.parameters.sortField = field;
        this.local.parameters.sortOrder = order;
        await this.resetPagingAndLoadData();
    }

    async onPageChange(page: number) {
        this.local.parameters.page = page;
        this.parameterService.set(this.local.parameters);
        await this.loadAsyncData();
    }

    @Watch('local.parameters.type')
    selectedVehicleMakeTypeChange() {
        if (this.local.loading) {
            return;
        }

        this.resetPagingAndLoadData();
    }

    getVehicleMakeTypeLabel(id: string): string {
        return getOptionLabel(id, this.local.vehicleMakeTypeOptions);
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }

    onRowClick(row: VehicleMake): void {
        if (this.local.selected && row.id === this.local.selected.id) {
            this.local.selected = undefined;
        }
    }

    private async loadAsyncData() {
        const backendParameters = this.parameterService.getBackendParameters();
        this.local.total =
            (await getResourcePagingNew(this.resourceType, backendParameters)).rowCount;

        this.local.rows = [];

        const rows: VehicleMake[] = await getResourcesNew(this.resourceType, this.local.parameters.page, backendParameters);

        rows.forEach((row) => {
            this.local.rows.push(row);
        });

        if (this.local && this.local.rows.indexOf(this.local.selected!!) == -1) {
            this.local.selected = undefined;
        }
    }

    private async resetPagingAndLoadData() {
        this.local.parameters.page = 1;
        this.parameterService.set(this.local.parameters);
        await this.loadAsyncData();
    }
}
